import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import {Dropdown} from 'primereact/dropdown';
import {DataTable} from 'primereact/datatable';
import axios from '../../../axios-url';
import {Column} from 'primereact/column';
import {Calendar} from 'primereact/calendar';
import {InputSwitch} from 'primereact/inputswitch';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';    
import moment from 'moment';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import {InputMask} from 'primereact/inputmask';
import {  DROPDOWN_CONFIG, PEOPLE_SUBMENU_ID, VENDOR_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, TIME_DURATION, REDIRECT_TO_URL } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import { filter } from 'lodash';
import { RadioButton } from 'primereact/radiobutton';


const CountryCodeOptions = [
    { label: 'UAE (+971)', value: '+971' },
    { label: 'India (+91)', value: '+91' },
    { label: 'USA (+1)', value: '+1' },
    { label: 'UK (+44)', value: '+44' },
    { label: 'Canada (+1)', value: '+1' },
    { label: 'Australia (+61)', value: '+61' },
    { label: 'Saudi Arabia (+966)', value: '+966' },
    { label: 'Germany (+49)', value: '+49' },
    { label: 'Kuwait (+965)', value: '+965' },
];
class AddPeople extends Component {
    state = {
        docType: null,
        docDocumentNo: null,
        display: true,
        rows: [],
        type: 'add',
        vendorId: '',
        vendorNo: '',
        businessType: '',
        vendordocs: [],
        VendorType: null,
        DocExpiryDate: '',
        DocIssuDate: '',
        vendorName: '',
        // Shared address field
        // Address: '',
        billingName: '',
        billingPosition: '',
        billingEmail: '',
        timesheetName: '',
        timesheetPosition: '',
        timesheetEmail: '',
        procurementName: '',
        procurementPosition: '',
        procurementEmail: '',
        actionType: '',
        taxtIn: '',
        CrNo: '',
        bank: '',
        bankBranch: '',
        bankAddress: '',
        bankIban: '',
        isActive: false,
        Blocked: false,
        billingMobile: '',
        timesheetMobile: '',
        procurementMobile: '',
        rowData: null,

        // Add people (initial values)
        // 
        PeopleNumber: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        FatherName: '',
        FamilyName: '',
        City: null,
        Street: '',
        Address: '',
        Language: '',
        ResidentCountry: null,
        Email_Id: '',
        CountryCode: '',
        MobileNumber: '',
        Functional_Role: '',
        Gender: '',
        Nationality: '',
        DateOfBirth: null,
        Age: '',
        // UI helpers
        Person_no: '',
        PersonName: '',
        touch: false,
    }

    

    componentDidMount(){       
        let type = this.props.match.params.type;
        
        if (type !=='add'){
            let PeopleId = this.props.match.params.id;
            this.props.getMasterTableList(`Employee/GetPeople?PeopleId=${PeopleId}`);
        }   
        // if (type !=='add'){
        //     let vendorId = this.props.match.params.id;
        //     this.props.getMasterTableList(`Employee/GetVendor?VendorId=${vendorId}`);
        // }   
        
        
        
        this.getAccess = HASACCESS(PEOPLE_SUBMENU_ID);
        this.props.getMasterKeywordList('City'); 
        // this.props.getMasterKeywordList('VendorType');
        this.props.getMasterKeywordList('Country');
        
        if(type !== 'add'&& this.props.tableLists.length>0){
            setTimeout(() => {
                
                this.fetchSingleProcess();
            },1000)
        }
    }

    //need to change
    fetchSingleProcess = () =>{
        
        
        // let type = this.props.match.params.type;
        // let VendorMaster = this.props.tableLists;
        // let vendors = VendorMaster.vendor;
        // let vendordocuments = [];
        // vendordocuments = VendorMaster.vendorDocuments;
        
        //need to change 
        let type = this.props.match.params.type;
        let PeopleMaster = this.props.tableLists;
        let People = PeopleMaster.people;
        // let vendordocuments = [];
        // vendordocuments = VendorMaster.vendorDocuments;
        
        
        // var data = {
        //             type:type,
                    
        //             vendorId : vendors.vendorId,
        //             vendorNo : vendors.vendorNo,
        //             VendorType : vendors.businesstype,
        //             vendorName : vendors.vendorName,
        //             Address : vendors.address,
        //             billingName : vendors.contactPersonBilling,
        //             billingPosition : vendors.contactPositionBilling,
        //             billingEmail : vendors.emailBilling,
        //             timesheetName : vendors.contactPersonTimesheet,
        //             timesheetPosition : vendors.contactPositionTimesheet,
        //             timesheetEmail : vendors.emailTimesheet,
        //             procurementName : vendors.contactPersonProcurement,
        //             procurementPosition : vendors.contactPositionProcurement,
        //             procurementEmail : vendors.emailProcurement,
        //             actionType : vendors.actionType,
        //             taxtIn : vendors.taxtin,
        //             CrNo : vendors.crno,
        //             bank : vendors.bank,
        //             bankBranch : vendors.bankbranch,
        //             bankAddress : vendors.bankaddress,
        //             bankIban : vendors.bankiban,
        //             isActive : vendors.isactive,
        //             Blocked : vendors.blocked,
        //             billingMobile: vendors.contactnumberbilling,
        //             timesheetMobile : vendors.contactnumbertimesheet,
        //             procurementMobile : vendors.contactnumberprocurement,
        //             City : vendors.city,
        //             Country : vendors.country,
        //             vendordocs :  vendordocuments,
                    
        //             vid : vendors.id
                    

                    
                    

        //         }
        var data = {
                type:type,


                PeopleId: People.peopleId,
                PeopleNumber: People.peopleNumber,
                FirstName: People.FirstName,
                MiddleName: People.MiddleName || '', // Add field to state/UI if needed
                LastName: People.LastName || '',     // Add field to state/UI if needed
                FatherName: People.FatherName || '', // Add field to state/UI if needed
                FamilyName: People.FamilyName,
                City: People.City,
                Street: People.Street || '',         // Add field to state/UI if needed
                Address: People.Address,
                Language: People.Language || '',     // Add field to state/UI if needed
                ResidentCountry: People.Country,
                Email_Id: People.Email_Id,
                MobileNumber: People.MobileNumber,
                Functional_Role: People.FunctionalRole || '', // Add field to state/UI if needed
                Gender: People.Gender,
                Nationality: People.Nationality || '',        // Add field to state/UI if needed
                DateOfBirth: People.DateOfBirth,
            }
                this.setState(data);
                
                
            }
        




    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeField(rowIndex)} ></Button>
        </div>;
    }
    // DocIssuDate: (this.state.DocIssuDate!==null) ? new Date(this.state.DocIssuDate) : '', DocExpiryDate: (this.state.DocExpiryDate!==null) ? new Date(this.state.DocExpiryDate) : ''

     //age calculation 
     calculateAge = (dob) => {
  if (!dob) return '';
  const today = new Date();
  const birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

    documentAdd = () => {

        let newDoc = { docType: this.state.docType, docDocumentNo: this.state.docDocumentNo };
  
        let docValue = [...this.state.vendordocs, newDoc];
      
        this.setState({vendordocs:docValue})
    }

    addVisaQuota = () => {

        let newDoc = {visaType : this.state.visaType, usedQ:this.state.usedQ,balanceQ:this.state.balanceQ,allocated:0};
        let docValue = [...this.state.VisaQuota, newDoc];
        this.setState({VisaQuota:docValue,usedQ:'',balanceQ:'',allocated:''})
    }

    docActionTemplate = (rowData, column) => {
        
        let rowIndex = column.rowIndex;
        
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.deleteDocType(rowIndex)}></Button>
        </div>;
    }

    
    typeEditor = (props) => {
        let types = [
            {label:'Own',value:'Own'},
            {label:'Dependent',value:'Dependent'}
        ];

        return (
            <Dropdown value={props.value[props.rowIndex].depType} options={types}
                    onChange={(e) => this.onEditorValueChange(props, e.value)} style={{width:'100%'}} placeholder="---Select---"/>
        );
    }


    deleteDocType = (removeIndex) => {

        const updatedVendorValue = this.state.vendordocs.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({vendordocs:updatedVendorValue})

    }

    add = () => {
        const { loggedUserDetail } = this.props;
        const now = new Date();

        // let VendorDocuments = []
        // let Vendor = {
            
        //     VendorNo : this.state.vendorNo,
        //     Businesstype : this.state.VendorType,
        //     VendorName : this.state.vendorName,
        //     Address : this.state.Address,
        //     City : this.state.City,
        //     Country : this.state.Country,
        //     ContactPersonBilling : this.state.billingName,
        //     ContactPositionBilling : this.state.billingPosition,
        //     EmailBilling : this.state.billingEmail,
        //     ContactPersonTimesheet : this.state.timesheetName,
        //     ContactPositionTimesheet : this.state.timesheetPosition,
        //     EmailTimesheet : this.state.timesheetEmail,
        //     ContactPersonProcurement : this.state.procurementName,
        //     ContactPositionProcurement  : this.state.procurementPosition,
        //     EmailProcurement : this.state.procurementEmail,
        //     ActionType : this.state.actionType,
        //     Taxtin : this.state.taxtIn,
        //     Crno : this.state.CrNo,
        //     Bank : this.state.bank,
        //     Bankbranch : this.state.bankBranch,
        //     Bankaddress : this.state.bankAddress,
        //     Bankiban : this.state.bankIban,
        //     Isactive : this.state.isActive,
        //     Blocked : this.state.Blocked,
        //     Contactnumberbilling: this.state.billingMobile,
        //     Contactnumbertimesheet : this.state.timesheetMobile,
        //     Contactnumberprocurement : this.state.procurementMobile
        // }
        let People = {  
            PeopleNumber: this.state.PeopleNumber,
            FirstName: this.state.FirstName,
            MiddleName: this.state.MiddleName || '',
            LastName: this.state.LastName || '',
            FatherName: this.state.FatherName || '',
            FamilyName: this.state.FamilyName,
            City: this.state.City,
            Street: this.state.Street || '',
            Address: this.state.Address,
            Language: this.state.Language || '',     // Add field to state/UI if needed
            ResidentCountry: this.state.ResidentCountry,
            Email_Id: this.state.Email_Id,
            MobileNumber: this.state.Phone_no,
            Functional_Role: this.state.FunctionalRole || '', // Add field to state/UI if needed
            Gender: this.state.Gender,
            Nationality: this.state.Nationality || '',        // Add field to state/UI if needed
            DateOfBirth: this.state.DateOfBirth,
            Createdby : loggedUserDetail.userId,
            // Createddate : now,
            Updatedby : null,
            Updateddate : null
         }
        
        // VendorDocuments = this.state.vendordocs.map(list => {
        //     return {
                
                
        //         DocType :list.docType,
        //         DocDocumentNo :list.docDocumentNo,
        //         DocIssuPlace :null,
        //         Createdby :null,
        //         Createddate :null,
        //         Updatedby :null,
        //         Updateddate :null,
        //         CompanyId :null,
        //         IsActive :null,
        //         UploadPath : null,
        //         FileName : null,
        //         Extension : null,
        //         Status : null
        //     }
        // } ) 

        let VendorMaster = []
        let PeopleMaster = []  
        if(this.state.type === 'edit'){
           
            // Vendor.VendorId = this.props.match.params.id;  
            // Vendor.Id = this.state.vid
             
            //new
            People.PeopleId = this.props.match.params.id;
            // People.Id = this.state.
            
            
            // var updatedVendorDocuments = VendorDocuments.map((doc) => {
            //     doc.Vendordocumentid = this.state.vendordocs[0].vendordocumentid;
            //     doc.Id = this.state.vendordocs[0].id;
            //       return doc } )
                
                
// need to change
            // VendorMaster  = {
            //         Vendor : Vendor,
            //         VendorDocuments : updatedVendorDocuments
            //     } 
            PeopleMaster  = {
                    People : People,
                    Lastupdatedby : loggedUserDetail.userId,
                    Lastupdateddate : now
                    // PeopleDocuments : updatedVendorDocuments
                } 
             } 
            
            
        

        if(this.state.type === 'add'){
        //     VendorMaster  = {
        //     Vendor : Vendor,
        //     VendorDocuments : VendorDocuments
        // }
         PeopleMaster  = {
                    People : People,
                    Createddate: now,
                    // PeopleDocuments : updatedVendorDocuments
                } 
    }

        
        
        
        // this.props.processDynamicData('Vendor',this.state.type,VendorMaster,'Employee/GetVendor?VendorId=${this.props.match.params.id}');
        
        this.props.processDynamicData('People',this.state.type,PeopleMaster,'Employee/GetPeopleList');  //need to change
    }

    resetData = () => {
        this.setState ({    
        docType : null,
        docDocumentNo : null,
        display : true,
        rows: [],
        type : 'add',
        City : null,
        Country : null,
        vendorId : '',
        vendorNo : '',
        businessType : '',
        vendordocs :[],
        VendorType : null,
        DocExpiryDate : '',
        DocIssuDate : '',
        vendorName : '',
        Address : '',
        billingName : '',
        billingPosition : '',
        billingEmail : '',
        timesheetName : '',
        timesheetPosition : '',
        timesheetEmail : '',
        procurementName : '',
        procurementPosition : '',
        procurementEmail : '',
        actionType : '',
        taxtIn : '',
        CrNo : '',
        bank : '',
        bankBranch : '',
        bankAddress : '',
        bankIban : '',
        isActive : false,
        Blocked : false,
        billingMobile: '',
        timesheetMobile : '',
        procurementMobile : '',
        rowData : null,

         //Reset people daata for current entry  
        PeopleNumber: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        FatherName: '',
        FamilyName: '',
        City: null,
        Street: '',
        Address: '',
        Language: '',
        ResidentCountry: null,
        Email_Id: '',
        MobileNumber: '',
        Functional_Role: '',
        Gender: '',
        Nationality: '',
        DateOfBirth: null,
        Age: '',
        // UI helpers
        Person_no: '',
        PersonName: '',
        touch: false
        });        
    }

    noEditor =  (props) => {
        return this.inputTextEditor(props, 'percentage');
    }
    
    issuedEditor =  (props) => {
        return this.inputCalendarEditor(props, 'issuedDate');
    }

    expiryEditor =  (props) => {
        return this.inputCalendarEditor(props, 'expiryDate');
    }

    placeEditor =  (props) => {
        return this.inputTextEditor(props, 'issuedPlace');
    }

    onEditorValueChange = (props, value) => {
        let updatedValue = [...props.value];
        updatedValue[props.rowIndex][props.field] = value;
        this.setState({documentDetails: updatedValue});
    }

    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }
    
    inputCalendarEditor = (props, field) => {
        return <InputMask mask="99/99/9999" slotChar="dd/mm/yyyy" placeholder="Date" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />
        
    }

    removeField  = (removeIndex) => {

        const updatedDeptValue = this.state.rows.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({rows:updatedDeptValue})

    }

    change = (e) => {
        let { name, value } = e.target;
        if (name === 'DateOfBirth') {
            const age = this.calculateAge(value);
            this.setState({ DateOfBirth: value, Age: age, touch: true });
            
        } else {
            this.setState({ [name]: value, touch: true });
            
        }
    }

    // checkDuration = () => {
    //     if(this.state.LunchStart !=='' && this.state.LunchEnd !==''){
    //         let LunchStart = new moment(this.state.LunchStart);
    //         LunchStart = LunchStart.format("HH:mm");
    //         let LunchEnd = new moment(this.state.LunchEnd);
    //         LunchEnd = LunchEnd.format("HH:mm");
    //         let LunchDuration = TIME_DURATION(LunchStart,LunchEnd);
    //         let checkTst = LunchDuration.split(':');
    //         if(checkTst[0] < 0  && checkTst[1] < 0){
    //             this.growl.show({severity: 'error', summary: null, detail: 'Lunch duration should be positive digits'});  
    //         }else{
    //             this.setState({LunchDuration:LunchDuration})
    //         }
    //     }
    // }
    // VendorRender = (rowData) => {
        
    //     let vendorType = rowData.vendorType;
    //     let VendorType = '';

    //     if(this.props.VendorType && this.props.VendorType.length > 0){
    //         VendorName = this.props.VendorType.filter((type)=>{
    //             return type.value === vendorType
    //         }).reduce((result, el) => {
    //             return el.label;
    //         },'');
    //     }
    //     return VendorType;
    // }

    render() {   

        if(this.props.success){
            REDIRECT_TO_URL('/People/',this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        let isEnabled = (this.state.touch === true);
        // let isEnabled = (this.state.shiftName!=='' && this.state.ShiftId!=='' && this.state.Description!=='');
        return (
            <div className="p-grid ">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Add people</h1>
           
                        <div className="p-grid mt2">
                                {/* Required fields only, mapped to state */}
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="label">People Number<span className="requiredColor">*</span></label>
                                    <div className="mt1"><InputText className="p-col-12" name="PeopleNumber" value={this.state.PeopleNumber} placeholder="People Number" onChange={this.change} /></div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">First Name<span className="requiredColor">*</span></label>
                                    <div className="mt1"><InputText className="p-col-12" name="FirstName" placeholder="First Name" value={this.state.FirstName} onChange={this.change}/></div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Middle Name</label>
                                    <div className="mt1"><InputText className="p-col-12" name="MiddleName" placeholder="Middle Name" value={this.state.MiddleName || ''} onChange={this.change}/></div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Last Name</label>
                                    <div className="mt1"><InputText className="p-col-12" name="LastName" placeholder="Last Name" value={this.state.LastName || ''} onChange={this.change}/></div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Father Name</label>
                                    <div className="mt1"><InputText className="p-col-12" name="FatherName" placeholder="Father Name" value={this.state.FatherName || ''} onChange={this.change}/></div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Family Name<span className="requiredColor">*</span></label>
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Choose Family" options={this.props.FamilyNameOptions} name="FamilyName" value={this.state.FamilyName} onChange={this.change} {...DROPDOWN_CONFIG} />
                                    </div>
                                </div>
                                    <div className="p-col-12 p-md-6 p-lg-6">
                                        <label className="label">Father ID</label>
                                        <div className="mt1">
                                            <Dropdown className="p-col-12" placeholder="Select Father" options={this.props.FatherIdOptions} name="FatherId" value={this.state.FatherId} onChange={this.change} {...DROPDOWN_CONFIG} />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-6">
                                        <label className="label">Mother ID</label>
                                        <div className="mt1">
                                            <Dropdown className="p-col-12" placeholder="Select Mother" options={this.props.MotherIdOptions} name="MotherId" value={this.state.MotherId} onChange={this.change} {...DROPDOWN_CONFIG} />
                                        </div>
                                    </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Address<span className="requiredColor">*</span></label>
                                    <div className="mt1"><InputText className="p-col-12" name="Address" placeholder="Address" value={this.state.Address} onChange={this.change}/></div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Date of Birth<span className="requiredColor">*</span></label>
                                    <div className="mt1"><Calendar className="width100" placeholder="Date of Birth" name="DateOfBirth" value={this.state.DateOfBirth} onChange={this.change} showIcon/></div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">City<span className="requiredColor">*</span></label>
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Choose City" options={this.props.City} name="City" value={this.state.City} onChange={this.change} {...DROPDOWN_CONFIG} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Country<span className="requiredColor">*</span></label>
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Choose Country" options={this.props.Country} name="ResidentCountry" value={this.state.ResidentCountry} onChange={this.change} {...DROPDOWN_CONFIG} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Gender<span className="requiredColor">*</span></label>
                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                        <div className="p-col-12 p-md-6">
                                            <RadioButton value="male" name="Gender" onChange={this.change} checked={this.state.Gender === "male"} />
                                            <label htmlFor="rb1" className="p-radiobutton-label">Male</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                            <RadioButton value="female" name="Gender" onChange={this.change} checked={this.state.Gender === "female"}/>
                                            <label htmlFor="rb1" className="p-radiobutton-label">Female</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Contact Number(with Country code)<span className="requiredColor">*</span></label>
                                    <div className="mt1">
                                        {/* <Dropdown
                                        //    style={{margin}}
                                            options={CountryCodeOptions}
                                            name="CountryCode"
                                            value={this.state.CountryCode}
                                            onChange={this.change}
                                            placeholder="Code"
                                            {...DROPDOWN_CONFIG}
                                        /> */}
                                        <InputText className="p-col-8 p-md-4 p-lg-6" name="MobileNumber" placeholder="Enter Mobile Number" value={this.state.MobileNumber} onChange={this.change}/>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Email</label>
                                    <div className="mt1"><InputText className="p-col-12" name="Email_Id" placeholder="Enter Email Id" value={this.state.Email_Id} onChange={this.change}/></div>
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Language</label>
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Select Language" options={this.props.LanguageOptions} name="Language" value={this.state.Language} onChange={this.change} {...DROPDOWN_CONFIG} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Street</label>
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Select Street" options={this.props.StreetOptions} name="Street" value={this.state.Street} onChange={this.change} {...DROPDOWN_CONFIG} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label className="label">Nationality</label>
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Select Nationality" options={this.props.NationalityOptions} name="Nationality" value={this.state.Nationality} onChange={this.change} {...DROPDOWN_CONFIG} />
                                    </div>
                                </div>

                            {/* <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Bank Address <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="bankAddress" placeholder="bank Address" value={this.state.bankAddress}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Bank Iban <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="bankIban" placeholder="Bank Iban" value={this.state.bankIban}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                         
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                        <label htmlFor="input" style={{ marginRight: '10px' }} >Active</label> 
                                        <InputSwitch checked={this.state.isActive} value={this.state.isActive} name="isActive" onChange={this.change}/> 
                                            
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                        <label htmlFor="input" style={{ marginRight: '10px' }} >Blocked</label> 
                                        <InputSwitch checked={this.state.Blocked} value={this.state.Blocked} name="Blocked" onChange={this.change}/> 
                                            
                            </div> */}
                            {/* <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Billing" toggleable={true}>
                               
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Contact Person</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Name"  name="billingName" value={this.state.billingName} onChange={this.change}/>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Position</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Position"  name="billingPosition" value={this.state.billingPosition} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Email</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Email"  name="billingEmail" value={this.state.billingEmail} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Mobile</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Mobile"  name="billingMobile" value={this.state.billingMobile} onChange={this.change}/>
                                        </div>

                                    </div> 
                                </Panel>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Timesheet" toggleable={true}>
                               
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Contact Person</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Name" name="timesheetName" value={this.state.timesheetName} onChange={this.change}/>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Position</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Position"  name="timesheetPosition" value={this.state.timesheetPosition} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Email</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Email"  name="timesheetEmail" value={this.state.timesheetEmail} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Mobile</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Mobile"  name="timesheetMobile" value={this.state.timesheetMobile} onChange={this.change}/>
                                        </div>

                                    </div> 
                                </Panel>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Procurement" toggleable={true}>
                               
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Contact Person</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Name"  name="procurementName" value={this.state.procurementName} onChange={this.change}/>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Position</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Position"  name="procurementPosition" value={this.state.procurementPosition} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Email</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Email" name="procurementEmail" value={this.state.procurementEmail} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Mobile</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Mobile"  name="procurementMobile" value={this.state.procurementMobile} onChange={this.change}/>
                                        </div>

                                    </div> 
                                </Panel>
                            </div> */}
                            
                            

                            {/* <div className="p-col-12 p-md-6 p-lg-12 mt3">
                                <div className="p-col-12 p-md-3 p-lg-2">
                                    <div className="mt1">
                                        <Button onClick={this.documentAdd}  label="Add" className="p-button-primary"/>
                                    </div>                                
                                </div>
                                <DataTable className="animated fadeIn" rowHover  responsive value={this.state.rows} editable={true}>
                                    <Column field="no" header="S.No"  style={{height: '3.5em'}}/>
                                    <Column field="hour" header="Hour"  style={{height: '3.5em'}}/>
                                    <Column field="percentage" header="Percentage" editor={this.noEditor} style={{height: '3.5em'}}/>
                                    <Column body={this.actionTemplate} header="Delete "style={{textAlign:'center', width: '8em'}}/>
                                </DataTable> 
                                </div> 
                            */}
                        </div> 
                            {/* <div className="mt3">
                                <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>
                                    <Button label="Add" style={{marginBottom:'10px'}} className="p-button-primary" onClick={this.documentAdd}/>
                                </div>
                        
                                <DataTable className="animated fadeIn" rowHover  responsive value={this.state.vendorTypes} editable={true}>
                                    <Column field="vendorType" header="Type" editor={this.typeEditor} style={{height: '3.5em'}}/>
                                    <Column field="documentType" header="Document Type" editor={this.docTypeEditor} style={{height: '3.5em'}}/>
                                    <Column field="doucmentNo" header="Document No" editor={this.noEditor} style={{height: '3.5em'}}/>
                                    <Column field="expiryDate" header="Expiry Date" editor={this.expiryEditor} style={{height: '3.5em'}}/>
                                    <Column field="issuedDate" header="Issued Date" editor={this.issuedEditor} style={{height: '3.5em'}}/>
                                    <Column field="issuedPlace" header="Issued Place" editor={this.placeEditor} style={{height: '3.5em'}}/>
                                    <Column body={this.docActionTemplate} style={{textAlign:'center', width: '8em'}}/>
                                </DataTable> 
                            </div> */}
                            
                           {/* <div className="mt3">
                <div className="p-grid">

                     <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Vendor Type</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={this.props.VendorType} name="vendorType" value={this.state.vendorType} onChange={event => this.setState({vendorType: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Vendor Type" style={{marginTop: '0.5em'}}/></div>   
                    </div>
                     */}
                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Document Type</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="docType" onChange={event => this.setState({docType: event.target.value})}  value={this.state.docType} placeholder="Enter Document Type" style={{marginTop: '0.5em'}}/>
                        </div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Document Number</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="docDocumentNo" onChange={event => this.setState({docDocumentNo: event.target.value})}  value={this.state.docDocumentNo} placeholder="Enter Document Type" style={{marginTop: '0.5em'}}/>
                        </div>                             
                    </div> */}
                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Expiry Date</label>
                        <div className="mt1">
                        <Calendar className="p-col-12" name="DocExpiryDate" onChange={event => this.setState({DocExpiryDate: event.target.value})}  value={this.state.DocExpiryDate} dateFormat="yy-mm-dd" placeholder="Choose Expiry Date"/>
                        </div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Issue Date</label>
                        <div className="mt1">
                        <Calendar className="p-col-12" name="DocIssuDate" onChange={event => this.setState({DocIssuDate: event.target.value})}  value={this.state.DocIssuDate} dateFormat="yy-mm-dd" placeholder="Choose Issue Date"/>
                        </div>                             
                    </div> */}
                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label" style={{visibility:"hidden"}}>.</label>
                        <div className="mt1">
                        <Button label="Add"  className="p-button-primary" onClick={this.documentAdd}/>
                        </div>
                    </div>
           
                    <div className="p-col-12">
                    <DataTable className="animated fadeIn mt2" rowHover  emptyMessage="No records found..." responsive value={this.state.vendordocs} editable={true}>
                        {/* <Column field="vendorType" header="Type" style={{height: '3.5em'}} body={this.VendorRender}/> */}
                        {/* <Column field="docType" header="Document Type" style={{height: '3.5em'}}/> */}
                        {/* <Column field="docDocumentNo" header="Document Number" style={{height: '3.5em'}}/> */}
                        {/* <Column field="DocExpiryDate" header="Expiry Date"  style={{height: '3.5em'}}/>
                        <Column field="DocIssuDate" header="Issued Date" style={{height: '3.5em'}}/> */}
                        {/* if (this.state.type == 'add') { */}
                        {/* <Column body={this.docActionTemplate} /> */}
                        {/* if (this.state.type == 'edit') {
                        <Column body={this.docTemplate} />} */}
                    {/* </DataTable>  */}
                    {/* </div>  */}

                {/* </div> */}
            {/* </div>  */}
                       
                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton}  type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/People"} />
                            </div>
                                 
           
                       
                    </div>
                         
                </div>
                
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists,
        City: (state.keyword.City!==undefined) ? state.keyword.City : [],
        Country: (state.keyword.Country!==undefined) ? state.keyword.Country : [],
        VendorType : (state.keyword.VendorType!==undefined) ? state.keyword.VendorType : [], 
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(AddPeople);